import { MetaDefinition } from '@angular/platform-browser';

import { HomeBanner, HomeSection } from '@app/modules/shared/home-sections/entities/home-data.response';

export type HomeItemDetail = Readonly<{
  code: string;
  logo_url: string;
  title: string;
  sub_title: string,
  store_type: string,
  branch_code: string,
  back_link: string,
  banners: HomeBanner[],
  sections: HomeSection[],
  widgets: string,
  login_required: boolean;
  airline_code?: string,
  destination_code?: string,
  metas?: MetaDefinition[],
  footer_content?: string
  footer_operated_by?: string;
  visibility_only_prime?: boolean;
}>;

export enum HomeItemDetailWidgetType {
  Air = 'air',
  Hotel = 'hotel',
  Bus = 'bus',
  Auto = 'auto',
  Package = 'package',
  Marriott = 'marriott',
  Byhours = 'byhours',
  Activities = 'activities'
}
